import React from "react";
import Stepper from "../../components/steper/Stepper";
import "./scuccess.css";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
const Success = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const onLogoutHandle = () => {
    localStorage.clear();
    dispatch({ type: "auth/logout" });
    navigate("/loginscreen");
  };
  return (
    <>
      <div className="root_main_container">
        <div className="hader">{/* <p> Registered as a company</p> */}</div>
        <Stepper currentStep={3} />
        <div className="form-container">
          <div className="box_root">
            <DotLottieReact
              src="https://lottie.host/9e17e36a-9edc-4454-a038-89692919e62b/fe77HH43TT.lottie"
              //loop
              autoplay
            />
            <div className="root_txt_sc">
              <p>Registration Successful !!</p>
            </div>
          </div>
        </div>
        <div className="button_home">
          <button
            onClick={onLogoutHandle}
            type="button"
            class="btn btn-primary"
          >
            Back To Home
          </button>
        </div>
      </div>
    </>
  );
};
export default Success;
